/**
 * CoLab Mega Menu Module
 * Десктопне мега-меню з hover ефектами
 */

let menuItems = null;
let timeout = null;
const closeDelay = 150;

function init() {
    menuItems = document.querySelectorAll('.header__item[data-mega-menu]');
    if (!menuItems.length) return;

    bindEvents();
}

function bindEvents() {
    menuItems.forEach(function(item) {
        const link = item.querySelector('.header__link');
        const megaMenu = item.querySelector('.mega-menu');

        if (!megaMenu) return;

        // Mouse enter
        item.addEventListener('mouseenter', function() {
            openMenu(item);
        });

        // Mouse leave with delay
        item.addEventListener('mouseleave', function() {
            closeMenuDelayed(item);
        });

        // Keyboard navigation
        if (link) {
            link.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleMenu(item);
                }
            });
        }
    });

    // Close on escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeAll();
        }
    });

    // Close on click outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.header__item[data-mega-menu]')) {
            closeAll();
        }
    });
}

function openMenu(item) {
    clearTimeout(timeout);

    // Close other menus
    menuItems.forEach(function(otherItem) {
        if (otherItem !== item) {
            otherItem.classList.remove('is-open');
        }
    });

    item.classList.add('is-open');
}

function closeMenuDelayed(item) {
    timeout = setTimeout(function() {
        item.classList.remove('is-open');
    }, closeDelay);
}

function toggleMenu(item) {
    item.classList.toggle('is-open');
}

function closeAll() {
    menuItems.forEach(function(item) {
        item.classList.remove('is-open');
    });
}

export const MegaMenu = {
    init
};
